import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { OverlayScrollbars } from 'overlayscrollbars';
import { Header } from '../organisms/Header';
// [2026-04-30] 모바일 GNB(BottomNav) 숨김 — 헤더 메뉴로 일원화. 컴포넌트는 보존.
// import { BottomNav } from '../organisms/BottomNav';
// [법인 전환 후 활성화] 실시간 시세 티커바
// import { PriceTickerBar } from '../organisms/PriceTickerBar';
// [법인 전환 후 활성화] 좌측 실시간 시세 사이드바
// import { PriceSidebar } from '../organisms/PriceSidebar';
import { PointToaster } from '../organisms/PointToaster';
import { Footer } from '../organisms/Footer';
import { AdBanner, resolveWingAdSlot } from '@/components/ads/AdBanner';
import { useAppSocket } from '@/hooks/useSocket';

export function DefaultLayout() {
  useAppSocket();

  /* 현재 라우트에 매칭되는 wing 광고 슬롯 — AdBanner 의 WING_AD_ROUTE_MAP 기반.
     매치 없으면 기본 슬롯(display-v). key 변경 시 AdBanner 가 새로 마운트되어 새 광고 push. */
  const { pathname } = useLocation();
  const wingSlot = resolveWingAdSlot(pathname);

  // PC 에서만 body 스크롤에 OverlayScrollbars 적용
  useEffect(() => {
    const isPC = window.matchMedia('(min-width: 768px) and (hover: hover)').matches;
    if (!isPC) return;

    const osInstance = OverlayScrollbars(
      { target: document.body, cancel: { nativeScrollbarsOverlaid: false } },
      {
        scrollbars: {
          theme: 'os-theme-sisegonggan',
          autoHide: 'leave',
          autoHideDelay: 800,
        },
      },
    );

    return () => osInstance.destroy();
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-[var(--color-bg)]">
      <Header />
      {/* [법인 전환 후 활성화] 모바일 전용 가로 티커바 (PC 는 우측 PriceSidebar 로 대체)
      <div className="md:hidden">
        <PriceTickerBar />
      </div>
      */}
      {/* 컨텐츠 영역 — 사용자 요청에 따라 main 상단 padding 을 pt-1.5(6px) 로 축소.
          헤더 h-14(56px) + main pt-1.5(6px) = 62px 부터 컨텐츠 시작.
          페이지 내부의 추가 padding(`container-base py-N` 등) 은 페이지 디자인 의도 그대로 유지. */}
      <main className="flex-1 pt-1.5">
        <Outlet />
      </main>
      {/* [법인 전환 후 활성화] <PriceSidebar /> */}
      {/*
        컨테이너 우측 고정 날개 광고 (#4 display-v) — 사이트 전역 노출.
        - 컨테이너는 container-base max-w-6xl(1152px) 중앙 정렬.
          → 컨테이너 우측 경계 = `calc(50% + 576px)` (1152/2 = 576px).
          → 날개 왼쪽 시작점 `calc(50% + 584px)` (컨테이너 오른쪽 8px 여백).
        - xl(1280px+) 에서 노출. 1280px 에선 광고(w-[160px]) 가 뷰포트 끝을 살짝 벗어남 —
          2xl(1536px+) 이상에서 완전히 잘림 없이 보임. 그 사이는 overflow-hidden 으로 우측만 클리핑.
        - ignoreExcluded 로 모든 경로(admin/settings 포함) 에서도 노출 — "사이트 모든 곳" 요청 반영.
      */}
      <aside
        className="pointer-events-none fixed top-[120px] z-10 hidden w-[160px] xl:block xl:left-[calc(50%+584px)]"
        aria-label="광고"
      >
        <div className="pointer-events-auto">
          {/* key={wingSlot} — 경로 변경으로 슬롯이 바뀌면 AdBanner 를 새로 마운트하여
              새 slot 으로 adsbygoogle.push() 재실행 (AdSense 는 같은 <ins> 에 중복 push 금지). */}
          <AdBanner key={wingSlot} slot={wingSlot} className="w-full" ignoreExcluded />
        </div>
      </aside>
      <Footer />
      <PointToaster />
    </div>
  );
}
